import { FormikErrors } from 'formik';
import { combineActions, handleActions } from 'redux-actions';
import { userDocumentCreateError } from './action';
import { FormValues } from './view';

interface State {
  errors: FormikErrors<Partial<FormValues>>;
}

const initialState: State = {
  errors: {},
};

const reducer = handleActions(
  {
    [String(combineActions(userDocumentCreateError))]: (state, { payload }) => {
      return { ...state, errors: payload.errors };
    },
  },
  initialState,
);

export default reducer;
